// extracted by mini-css-extract-plugin
export default {"container":"styles_container__qfWhI","column":"styles_column__SwZbA","item":"styles_item__BSk5o"};